import React, { useEffect, useRef, useState } from 'react';
import { LoadPanel } from 'devextreme-react/load-panel';

type GoogleDocIFrameViewerProps = {
    url: string;
    height: string;
    width: string;
    title: string;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function GoogleDocIFrameViewer({ url, height, width, title }: GoogleDocIFrameViewerProps) {
    const [iframeTimeoutId, setIframeTimeoutId] = useState(undefined);
    const iframeRef = useRef(null);
    const [showLoadingIndicator, set_showLoadingIndicator] = useState(true);
    const loadingMessage = 'Loading...';

    useEffect(() => {
        const intervalId = setInterval(updateIframeSrc, 1000 * 4);
        setIframeTimeoutId(intervalId);
    }, []);

    function iframeLoaded() {
        set_showLoadingIndicator(false);
        clearInterval(iframeTimeoutId);
    }
    function getIframeLink() {
        return `https://docs.google.com/viewer?url=${url}&embedded=true`;
    }
    function updateIframeSrc() {
        if (iframeRef.current) {
            iframeRef.current.src = getIframeLink();
        }
    }

    return (
        <>
            <iframe
                title={title}
                onLoad={iframeLoaded}
                onError={updateIframeSrc}
                ref={iframeRef}
                src={getIframeLink()}
                height={height}
                width={width}
            />
            {iframeTimeoutId && (
                <LoadPanel
                    hideOnOutsideClick={false}
                    visible={showLoadingIndicator}
                    message={loadingMessage}
                />
            )}
        </>
    );
}
